import { type SVGProps } from 'react';

import { cn } from '@shared/utils';

export interface EyeIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function EyeIcon({ className, ...props }: Readonly<EyeIconProps>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-[#9CA3AF]', className)}
      aria-hidden="true"
      {...props}
    >
      <path
        d="M9.99951 12.5C11.3802 12.5 12.4995 11.3807 12.4995 10C12.4995 8.61929 11.3802 7.5 9.99951 7.5C8.6188 7.5 7.49951 8.61929 7.49951 10C7.49951 11.3807 8.6188 12.5 9.99951 12.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.10235 9.53891C2.34173 5.81309 5.85611 3.125 9.99994 3.125C14.1419 3.125 17.6549 5.8106 18.8958 9.53371C18.9961 9.8346 18.9962 10.1601 18.8961 10.4611C17.6567 14.1869 14.1423 16.875 9.99848 16.875C5.85657 16.875 2.34354 14.1894 1.10263 10.4663C1.00234 10.1654 1.00225 9.83986 1.10235 9.53891ZM14.3745 10C14.3745 12.4162 12.4158 14.375 9.99951 14.375C7.58327 14.375 5.62451 12.4162 5.62451 10C5.62451 7.58375 7.58327 5.625 9.99951 5.625C12.4158 5.625 14.3745 7.58375 14.3745 10Z"
        fill="currentColor"
      />
    </svg>
  );
}
